const React = require('react');

const HomeHelpStatusRebranding = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M22.1191 3.19043H2.61914V22.6904H22.1191V3.19043ZM20.6191 15.1904V10.6904H4.11914V15.1904H20.6191ZM4.11914 16.6904V21.1904H20.6191V16.6904H4.11914ZM4.11914 9.19043H20.6191V4.69043H4.11914V9.19043Z" fill="#3483FA" />
  </svg>
);

module.exports = HomeHelpStatusRebranding;
